import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import { AppProvider } from "./contexts/AppContext";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ReservationMenuPage from "./pages/ReservationMenuPage/ReservationMenuPage";
import AppointmentSelectPage from "./pages/AppointmentSelectPage/AppointmentSelectPage";
import DatetimeSelectPage from "./pages/DatetimeSelectPage/DatetimeSelectPage";
import ReservationEntryPage from "./pages/ReservationEntryPage/ReservationEntryPage";
import AccountVerifyPage from "./pages/AccountVerifyPage/AccountVerifyPage";
import AccountLoginPage from "./pages/AccountLoginPage/AccountLoginPage";
import PatientSelectPage from "./pages/PatientSelectPage/PatientSelectPage";
import ReservationConfirmPage from "./pages/ReservationConfirmPage/ReservationConfirmPage";
import ReservationDonePage from "./pages/ReservationDonePage/ReservationDonePage";
import ReservationInformationPage from "./pages/ReservationInformationPage/ReservationInformationPage";
import QuestionnaireEntryPage from "./pages/QuestionnaireEntryPage/QuestionnaireEntryPage";
import QuestionnaireConfirmPage from "./pages/QuestionnaireConfirmPage/QuestionnaireConfirmPage";
import QuestionnaireDonePage from "./pages/QuestionnaireDonePage/QuestionnaireDonePage";
import AccountRegistPage from "./pages/AccountRegistPage/AccountRegistPage";
import CertificationNumberInputPage from "./pages/CertificationNumberInputPage/CertificationNumberInputPage";
import AccountRegistDonePage from "./pages/AccountRegistDonePage/AccountRegistDonePage";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPasswordPage";
import RegistNewPasswordPage from "./pages/RegistNewPasswordPage/RegistNewPasswordPage";
import MyPageMenuPage from "./pages/MyPage/MyPageMenuPage/MyPageMenuPage";
import UserSettingPage from "./pages/MyPage/UserSettingPage/UserSettingPage";
import FamilyListPage from "./pages/MyPage/FamilyListPage/FamilyListPage";
import FamilySettingPage from "./pages/MyPage/FamilySettingPage/FamilySettingPage";
import MailSettingPage from "./pages/MyPage/MailSettingPage/MailSettingPage";
import MedicalInstitutionListPage from "./pages/MyPage/MedicalInstitutionListPage/MedicalInstitutionListPage";
import UnsubscribeSettingPage from "./pages/MyPage/UnsubscribeSettingPage/UnsubscribeSettingPage";
import UnsubscribeDonePage from "./pages/MyPage/UnsubscribeDonePage/UnsubscribeDonePage";
import FaqListPage from "./pages/MyPage/FaqListPage/FaqListPage";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <Header />
        <div className="main">
          {/* メインページを切り替えるためのルート定義 */}
          <Routes>
            <Route path="/" element={<ReservationMenuPage />} />
            <Route path="/reservation-menu" element={<ReservationMenuPage />} />
            <Route
              path="/appointment-select"
              element={<AppointmentSelectPage />}
            />
            <Route path="/datetime-select" element={<DatetimeSelectPage />} />
            <Route
              path="/reservation-entry"
              element={<ReservationEntryPage />}
            />
            <Route path="/account-verify" element={<AccountVerifyPage />} />
            <Route path="/account-login" element={<AccountLoginPage />} />
            <Route path="/patient-select" element={<PatientSelectPage />} />
            <Route
              path="/reservation-confirm"
              element={<ReservationConfirmPage />}
            />
            <Route path="/reservation-done" element={<ReservationDonePage />} />
            <Route
              path="/reservation-information"
              element={<ReservationInformationPage />}
            />
            <Route
              path="/questionnaire-entry"
              element={<QuestionnaireEntryPage />}
            />
            <Route
              path="/questionnaire-confirm"
              element={<QuestionnaireConfirmPage />}
            />
            <Route
              path="/questionnaire-done"
              element={<QuestionnaireDonePage />}
            />
            <Route path="/account-regist" element={<AccountRegistPage />} />
            <Route
              path="/account-regist/certificatrion-number-input"
              element={<CertificationNumberInputPage />}
            />
            <Route
              path="/account-regist-done"
              element={<AccountRegistDonePage />}
            />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/reset-password/certificatrion-number-input"
              element={<CertificationNumberInputPage />}
            />
            <Route
              path="/regist-new-password"
              element={<RegistNewPasswordPage />}
            />
            <Route path="/mypage/menu" element={<MyPageMenuPage />} />
            <Route path="/mypage/user-setting" element={<UserSettingPage />} />
            <Route path="/mypage/family-list" element={<FamilyListPage />} />
            <Route
              path="/mypage/family-setting"
              element={<FamilySettingPage />}
            />
            <Route path="/mypage/mail-setting" element={<MailSettingPage />} />
            <Route
              path="/mypage/mail-setting/certificatrion-number-input"
              element={<CertificationNumberInputPage />}
            />
            <Route
              path="/mypage/password-setting"
              element={<ResetPasswordPage />}
            />
            <Route
              path="/mypage/password-setting/certificatrion-number-input"
              element={<CertificationNumberInputPage />}
            />
            <Route
              path="/mypage/password-setting/regist-new-password"
              element={<RegistNewPasswordPage />}
            />
            <Route
              path="/mypage/medical-institution-list"
              element={<MedicalInstitutionListPage />}
            />
            <Route
              path="/mypage/unsubscribe"
              element={<UnsubscribeSettingPage />}
            />
            <Route
              path="/mypage/unsubscribe/done"
              element={<UnsubscribeDonePage />}
            />
            <Route
              path="/mypage/account-login"
              element={<AccountLoginPage />}
            />
            <Route
              path="/mypage/faq-list"
              element={<FaqListPage />}
            />
          </Routes>
        </div>
        <Footer />
      </AppProvider>
    </div>
  );
}

export default App;
